import { ref } from 'vue'

import { defineStore } from 'pinia'

/**
 * Shared UI state for the My Courses search input.
 *
 * The input lives in the Client Portal top bar (shell) while the grid that
 * consumes the query lives in the courses page, so the value is held here to
 * bridge the two without prop drilling through the shell.
 *
 * NO server data, NO service imports, NO API calls.
 */
export const useMyCoursesSearchStore = defineStore('my-courses-search-ui', () => {
  const searchQuery = ref('')

  const setSearchQuery = (value: string) => {
    searchQuery.value = value
  }

  const reset = () => {
    searchQuery.value = ''
  }

  return {
    searchQuery,
    setSearchQuery,
    reset,
  }
})
